import { useContext } from 'react';
import { WrappedFieldProps } from 'redux-form';
import Markdown from 'shared/components/Markdown';
import { SPACINGS } from 'shared/styles/variables';
import styled, { ThemeContext } from 'styled-components';

import { errorStyles, labelStyles } from 'inquiry/mixins/form';
import FormControlProps from 'lib/interfaces/FormControlProps';
import { InputStyles } from 'lib/interfaces/input-styles';
import MaterialSelect from 'verify/components/MaterialSelect';
import Select from 'verify/components/Select';

interface ContainerProps {
  inputStyle: InputStyles;
}

const Container = styled('div')<ContainerProps>`
  margin-bottom: ${SPACINGS.base * 2}px;
  ${({ inputStyle }) =>
    inputStyle === InputStyles.Material ? `padding-top: ${SPACINGS.base * 2}px;` : ''};
  text-transform: capitalize;
`;

const OutlinedLabelContainer = styled('div')`
  ${labelStyles}
`;

const FormError = styled('div')`
  ${errorStyles};
  padding-left: ${SPACINGS.base}px;
`;

interface ThemedFormSelectProps extends FormControlProps {
  className?: string;
  id?: string;
  label?: string;
  serverError?: string;
}

function ThemedFormSelect(props: ThemedFormSelectProps & WrappedFieldProps) {
  const {
    id,
    input,
    label,
    serverError,
    meta: { error, submitFailed },
    ...passThroughProps
  } = props;
  const { inputStyle } = useContext(ThemeContext);
  const errorToDisplay = (submitFailed && error) || serverError;
  const hasError = !!errorToDisplay;

  switch (inputStyle) {
    case InputStyles.Material:
      return (
        <Container inputStyle={inputStyle}>
          {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
          <MaterialSelect {...input} {...passThroughProps} hasError={hasError} labelText={label} />
          {hasError && <FormError role='alert'>{errorToDisplay}</FormError>}
        </Container>
      );

    default:
    case InputStyles.Outlined:
      return (
        <OutlinedLabelContainer>
          {label && (
            <Markdown<'label'> wrapper='label' wrapperProps={{ htmlFor: id }}>
              {label}
            </Markdown>
          )}
          {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
          <Container inputStyle={inputStyle}>
            <Select {...input} {...passThroughProps} id={id} hasError={hasError} />
            {hasError && <FormError role='alert'>{errorToDisplay}</FormError>}
          </Container>
        </OutlinedLabelContainer>
      );
  }
}

export default ThemedFormSelect;
